// extracted by mini-css-extract-plugin
export default {"header":"header_header__RoG66","placeHolderShimmer":"header_placeHolderShimmer__h2O74"};